import React from 'react';
import PropTypes from 'prop-types';
import Component from '@ux/component';
import Toggle from './toggle';
import { BLOCK, DIRECTIONS } from './constants';

/**
 * Alert details.
 *
 * The details of an alert is any additional content that should be displayed.
 * Details can be toggled open or closed.
 *
 * @class Details
 * @public
 */
export default class Details extends Component {
  /**
   * Render the alert details if any content is provided. If no content is
   * provided then no details (including toggle) will be rendered.
   *
   * @returns {ReactElement} div
   * @public
   */
  render() {
    const props = this.props;
    if (!props.children) {
      return null;
    }

    const classNames = this.classNames(['alert-addon', 'collapse'], {
      in: props.display === BLOCK
    });

    return (
      <div>
        <div className={ classNames } aria-expanded={ props.display === 'none' ? 'false' : 'true' }>
          { props.children }
        </div>
        <Toggle onClick={ props.onClick } display={ props.display } />
      </div>
    );
  }
}

/**
 * Property types.
 *
 * @type {Object}
 * @private
 */
Details.propTypes = {
  /** Handler for when the alert details toggle is clicked */
  onClick: PropTypes.func.isRequired,
  /** How to display the additional alert details */
  display: PropTypes.oneOf(Object.keys(DIRECTIONS)),
  /** Alert details content */
  children: PropTypes.node
};
